/**
 * LANNA Studio - Collection Ritual Filtering, In-Stock Toggle & Instant Sorting
 */
document.addEventListener('DOMContentLoaded', function () {
  function initCollectionFilters() {
    const filterBar = document.querySelector('.ritual-filter-bar');
    const productGrid = document.getElementById('product-grid');
    const inStockToggle = document.getElementById('Filter-InStock');
    const sortSelect = document.getElementById('CollectionSortBy');
    const itemCounter = document.getElementById('CollectionItemCounter');

    if (!productGrid) return;

    const pills = filterBar ? filterBar.querySelectorAll('.ritual-filter-pill') : [];
    // Grab all initial product cards
    let items = Array.from(productGrid.querySelectorAll('.ritual-product-item'));
    if (items.length === 0) return;

    const totalVessels = items.length;

    // Helper: update pill badge counts
    function updatePillCounts(onlyInStock) {
      pills.forEach(function (pill) {
        const filterVal = pill.dataset.filter;
        const countBadge = pill.querySelector('.ritual-filter-pill__count');
        if (!countBadge) return;

        let matchCount = 0;
        items.forEach(function (item) {
          const isAvail = item.dataset.available === 'true';
          if (onlyInStock && !isAvail) return;

          if (filterVal === 'all') {
            matchCount++;
          } else {
            const targets = filterVal.split(',').map(function (s) { return s.trim().toLowerCase(); });
            const itemRituals = (item.dataset.rituals || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
            const isMatch = targets.some(function (t) { return itemRituals.includes(t); });
            if (isMatch) matchCount++;
          }
        });

        countBadge.textContent = '(' + matchCount + ')';
      });
    }

    // Helper: apply active ritual + stock filters
    function applyFilters() {
      const activePill = filterBar ? filterBar.querySelector('.ritual-filter-pill.is-active') : null;
      const filterVal = activePill ? activePill.dataset.filter : 'all';
      const onlyInStock = inStockToggle ? inStockToggle.checked : false;

      let visibleCount = 0;
      let animIndex = 0;

      items.forEach(function (item) {
        let matchesRitual = false;
        if (filterVal === 'all') {
          matchesRitual = true;
        } else {
          const targets = filterVal.split(',').map(function (s) { return s.trim().toLowerCase(); });
          const itemRituals = (item.dataset.rituals || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
          matchesRitual = targets.some(function (t) { return itemRituals.includes(t); });
        }

        let matchesStock = true;
        if (onlyInStock) {
          matchesStock = (item.dataset.available === 'true');
        }

        const isVisible = matchesRitual && matchesStock;

        if (isVisible) {
          visibleCount++;
          item.classList.remove('is-filtered-out');
          item.classList.remove('is-animating-in');
          void item.offsetWidth; // Trigger reflow for smooth animation
          item.classList.add('is-animating-in');
          item.style.animationDelay = (Math.min(animIndex, 8) * 0.035) + 's';
          animIndex++;
        } else {
          item.classList.add('is-filtered-out');
          item.classList.remove('is-animating-in');
        }
      });

      // Update counter
      if (itemCounter) {
        itemCounter.textContent = 'Showing ' + visibleCount + ' of ' + totalVessels + ' Vessels';
      }

      // Update badge numbers
      updatePillCounts(onlyInStock);

      // Handle empty state
      let emptyState = productGrid.querySelector('.ritual-empty-filter-state');
      if (!emptyState) {
        emptyState = document.createElement('li');
        emptyState.className = 'ritual-empty-filter-state';
        emptyState.innerHTML = '<h3>No Vessels Found</h3><p>No vessels currently match your selected ritual or availability criteria.</p>';
        productGrid.appendChild(emptyState);
      }
      emptyState.classList.toggle('is-visible', visibleCount === 0);
    }

    // Helper: sort product items in DOM
    function sortGrid(criteria) {
      items.sort(function (a, b) {
        if (criteria === 'price-ascending') {
          const pA = parseFloat(a.dataset.priceCents || a.dataset.price || 0);
          const pB = parseFloat(b.dataset.priceCents || b.dataset.price || 0);
          return pA - pB;
        } else if (criteria === 'price-descending') {
          const pA = parseFloat(a.dataset.priceCents || a.dataset.price || 0);
          const pB = parseFloat(b.dataset.priceCents || b.dataset.price || 0);
          return pB - pA;
        } else if (criteria === 'title-ascending') {
          const tA = (a.dataset.title || '').trim().toLowerCase();
          const tB = (b.dataset.title || '').trim().toLowerCase();
          return tA.localeCompare(tB);
        } else {
          // 'featured' - original order
          const oA = parseInt(a.dataset.featuredOrder || '0', 10);
          const oB = parseInt(b.dataset.featuredOrder || '0', 10);
          return oA - oB;
        }
      });

      const emptyState = productGrid.querySelector('.ritual-empty-filter-state');
      items.forEach(function (item) {
        if (emptyState) {
          productGrid.insertBefore(item, emptyState);
        } else {
          productGrid.appendChild(item);
        }
      });
    }

    // Event Listeners: Ritual Pills
    if (filterBar) {
      filterBar.addEventListener('click', function (e) {
        const pill = e.target.closest('.ritual-filter-pill');
        if (!pill) return;

        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');

        applyFilters();
      });
    }

    // Event Listener: In-Stock Toggle
    if (inStockToggle) {
      inStockToggle.addEventListener('change', function () {
        applyFilters();
      });
    }

    // Event Listener: Sort Dropdown
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortGrid(this.value);
        applyFilters();
      });
    }

    // Initial run
    updatePillCounts(false);
    applyFilters();
  }

  initCollectionFilters();
});
